import type { CalendarGridEvent } from '@/types/calendar/grid'

export function gridEventsByDate(events: CalendarGridEvent[]): Map<string, CalendarGridEvent[]> {
  const map = new Map<string, CalendarGridEvent[]>()
  for (const e of events) {
    const list = map.get(e.date) ?? []
    list.push(e)
    map.set(e.date, list)
  }
  return map
}

/** Strip time segments from subtitles (prototype eventLocation). */
export function eventLocation(subtitle?: string): string {
  if (!subtitle) return ''
  const hasTime = /\d{1,2}:\d{2}/
  return subtitle
    .split('·')
    .map((s) => s.trim())
    .filter((s) => s && !hasTime.test(s))
    .join(' · ')
}
